'use client';

import type { Series } from '@/types';
import dynamic from 'next/dynamic';
import { useCallback, useState } from 'react';

const SeriesInfoModal = dynamic(() => import('./index'), {
  ssr: false,
  loading: () => null,
});

type Source = 'home' | 'series_list';

export function useSeriesInfoModal(source: Source) {
  const [series, setSeries] = useState<Series | null>(null);
  const close = useCallback(() => setSeries(null), []);

  return {
    openInfo: setSeries,
    isOpen: series !== null,
    modal: <SeriesInfoModal series={series} onClose={close} source={source} />,
  };
}
